import { render } from "./multi-upload.vue?vue&type=template&id=4358477e"
import script from "./multi-upload.vue?vue&type=script&lang=js"
export * from "./multi-upload.vue?vue&type=script&lang=js"
script.render = render

export default script